import { ReactNode } from 'react';
import GlobalHeader from './GlobalHeader';

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div className="flex flex-col min-h-screen bg-dark text-gray-200 selection:bg-primary/30">
            <GlobalHeader />
            <main className="flex-1 flex flex-col min-w-0">
                {children}
            </main>
            <footer className="border-t border-slate/10 py-12 px-6">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
                    <p className="text-[10px] text-gray-600 uppercase tracking-widest font-bold">
                        © 2026 DIYMECH INTERFACE • QUANTUM CORE V4.5
                    </p>
                    <div className="flex gap-8">
                        {['Privacy', 'Terms', 'Docs', 'Status'].map((link) => (
                            <a key={link} href="#" className="text-[10px] text-gray-400 uppercase tracking-widest font-bold hover:text-white transition-colors">
                                {link}
                            </a>
                        ))}
                    </div>
                </div>
            </footer>
        </div>
    );
}
